import emailOptInSuccessModal from './emailOptInSuccessModal';

export default emailOptInSuccessModal;
